import { Popover, Stack, Text, VisuallyHidden } from "@hopper-ui/components";
import type { RefObject } from "react";

export const ACTIVITY_POPOVER_OFFSET = 10;

export interface ActivityCoachmarkProps {
    triggerRef: RefObject<HTMLButtonElement | null>;
    isOpen: boolean;
    onHoverChange: (isHovered: boolean) => void;
}

export function ActivityCoachmark({ triggerRef, isOpen, onHoverChange }: ActivityCoachmarkProps) {
    return (
        <Popover
            triggerRef={triggerRef}
            isOpen={isOpen}
            // Non-modal so it never takes focus away from the table the action was started from.
            isNonModal
            isNonDialog
            placement="bottom end"
            offset={ACTIVITY_POPOVER_OFFSET}
            UNSAFE_maxWidth="20rem"
        >
            <Stack
                gap="stack-xs"
                padding="inset-md"
                onMouseEnter={() => onHoverChange(true)}
                onMouseLeave={() => onHoverChange(false)}
            >
                <Text fontWeight="body-md-semibold" data-public>
                    Added to Activity
                </Text>
                <Text size="sm" color="neutral-weak" data-public>
                    Actions run in the background here. You can leave this page anytime.
                </Text>
            </Stack>
        </Popover>
    );
}

export interface ActivityStartedAnnouncementProps {
    startCount: number;
}

// The coachmark never takes focus, so screen readers learn about each start from this status region.
export function ActivityStartedAnnouncement({ startCount }: ActivityStartedAnnouncementProps) {
    // A trailing no-break space on every other start changes the text, so a repeated start is announced again.
    const suffix = startCount % 2 === 0 ? "" : "\u00A0";

    return (
        <VisuallyHidden role="status" data-public>
            {startCount > 0 ? `Added to Activity. Actions run in the background here.${suffix}` : ""}
        </VisuallyHidden>
    );
}
